
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prices",
      function () {
        return require("private-next-pages/prices/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prices"])
      });
    }
  